import ApiService from './_api.service'
import Utils from '../utils'

const API_SOLICITATIONS_URL = '/v1/solicitations/'
import { solicitationTypes } from '@/services/constants/index.js'

function solicitationItemsFactory(args, bodySource = 'request_body_web') {
    const { reason, response, ...item } = args

    function extraProductItem() {
        const { quantity, branch, product, ...rest } = item

        rest[bodySource] = {
            quantity: parseInt(quantity),
            branch,
            product: product?.id ?? product
        }

        return {
            ...rest,
            reason: reason?.id ?? reason,
            response
        }
    }

    function updateAssortmentParameterItem() {
        const {
            showcase_items,
            coverage,
            stack_items,
            stock_max,
            branchparameter,
            ...rest
        } = item

        rest[bodySource] = {
            showcase_items: parseInt(showcase_items),
            coverage: parseInt(coverage),
            stack_items: parseInt(stack_items),
            stock_max: parseInt(stock_max),
            branchparameter: branchparameter?.id ?? branchparameter
        }

        return rest
    }

    function addProductInAssortmentItem() {
        const { product, ...rest } = item

        rest[bodySource] = {
            product: product?.id ?? product
        }

        return rest
    }

    function updateAmplitudeParameterItem() {
        const { product, amplitude, node, quantity, nodes, colors, ...rest } = item

        rest[bodySource] = {
            amplitude: amplitude?.id ?? amplitude,
            node: node?.id ?? node,
            quantity: parseInt(quantity),
            colors,
            nodes
        }

        return rest
    }

    function favoriteProductItem() {
        const { branchparameter, ...rest } = item

        rest[bodySource] = {
            branchparameter: branchparameter.id
        }

        return rest
    }

    let items = []

    switch (item.solicitation_type) {
        case solicitationTypes.TYPE_REQUEST_EXTRA_PRODUCT_PK:
            items.push(extraProductItem())
            break
        case solicitationTypes.TYPE_UPDATE_ASSORTMENT_PARAMETER_PK:
            items.push(updateAssortmentParameterItem())
            break
        case solicitationTypes.TYPE_REMOVE_PRODUCT_PK:
        case solicitationTypes.TYPE_ADD_PRODUCT_SYSTEM_PK:
        case solicitationTypes.TYPE_ADD_PRODUCT_MANAGER_PK:
            items.push(addProductInAssortmentItem())
            break
        case solicitationTypes.TYPE_UPDATE_AMPLITUDE_PARAMETER_PK:
            items.push(updateAmplitudeParameterItem())
            break
        default:
            items.push(favoriteProductItem())
    }

    return items
}

function solicitationBody(args) {
    const solicitation = args.solicitation ? args.solicitation : args

    return {
        id: solicitation.id,
        status: solicitation.status,
        request_user: solicitation.request_user_id
            ? solicitation.request_user_id
            : solicitation.request_user.id,
        branch: solicitation.branch_id
    }
}

const SolicitationService = {
    // Solicitations Types
    readTypes: async function () {
        let url = API_SOLICITATIONS_URL + 'types/'
        const types = (await ApiService.get(url)).data
        return types.results
    },

    // Solicitations Reasons
    readReasons: async function () {
        let url = API_SOLICITATIONS_URL + 'reasons/'
        const reasons = (await ApiService.get(url)).data
        return reasons.results
    },

    // Solicitations
    readSolicitations: async function (args) {
        let url = API_SOLICITATIONS_URL

        const queryParams = Utils.getQueryParams(args)

        return ApiService.get(url + queryParams)
    },

    updateSolicitation: async function (args) {
        const solicitation = solicitationBody(args)

        const items = args.items
            ? args.items.map(item => {
                return solicitationItemsFactory(item)[0]
            })
            : solicitationItemsFactory({
                ...args,
                branch: solicitation.branch,
                solicitation: solicitation.id
            })

        const { id, ...rest } = solicitation

        const response = await ApiService.patch(
            API_SOLICITATIONS_URL + id + '/',
            {
                ...rest,
                source: 'W',
                response_user: parseInt(localStorage.user_id),
                items
            }
        )

        return response
    },

    async create(args) {
        const { body, items, ...rest } = args
        const response = await ApiService.post(
            API_SOLICITATIONS_URL,
            {
                ...rest,
                items: items.map(item => {
                    return solicitationItemsFactory(item, body)[0]
                })
            }
        )

        return response
    }
}

export default SolicitationService
